<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Management Devices" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Detail Device
                        .header-cta
                        router-link.btn-primary(to="/devices/create") Edit
            .box__body.p-4
                .flex.-mx-4
                    .block.px-4(class="w-1/2")
                        span.text-light  Device Location
                        .w-full(style="height:300px")
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.1738240507757!2d110.37531111477065!3d-7.771384694399184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a59b2d4729729%3A0xac4d7b5fcf34f8e4!2sGadjah%20Mada%20University!5e0!3m2!1sen!2sid!4v1591602090544!5m2!1sen!2sid" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    .block.px-4(class="w-1/2")
                        .block.mb-4
                            span.text-light  Device Name
                            h3.font-normal.text-gray-800 Device 1
                        
                        .block.mb-4.pt-4.border-t.border-dashed
                            span.text-light  IMEI
                            h3.monospace.text-gray-800.font-bold 876453827162
                        
                        .block.mb-4.pt-4.border-t.border-dashed
                            span.text-light  MISISDN
                            h3.monospace.text-gray-800.font-bold 0987654312617
                        
                        .block.mb-4.pt-4.border-t.border-dashed
                            span.text-light.mb-2.block  User
                            div.flex.items-center
                                figure.w-12.h-12.mr-4
                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/50.jpg")
                                span.text-light.name-index agilbaka
                                        
                
</template>

<script>

import HeaderGlobal from './../../components/HeaderGlobal.vue'


export default {
    name: 'PageDeviceDetail',
    components: {
        HeaderGlobal,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Devices',
                    url: '/devices',
                },
                {
                    name: "Device's name ",
                    url: '/devices/detail',
                },
            ],
         
        }
    },

   
}
</script>

<style lang="sass">
    .draw-area
        height: 500px
</style>


